import { render, staticRenderFns } from "./_internetClass.vue?vue&type=template&id=7a8e86b1&scoped=true"
import script from "./_internetClass.vue?vue&type=script&lang=js"
export * from "./_internetClass.vue?vue&type=script&lang=js"
import style0 from "./_internetClass.vue?vue&type=style&index=0&id=7a8e86b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8e86b1",
  null
  
)

export default component.exports